/* eslint max-classes-per-file: 0 */

import {
  CollectorPublication as Data,
  CollectorPublicationCollection as Collection,
} from '@/typings/api/CollectorPublication'
import { CollectorPublicationsApi as Api } from '@/api/resources/Collector'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class PublicationsTransformerParams extends TransformerParams {

}

export class PublicationsAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new PublicationsTransformerParams();
}
